import Tooltip from '@components/Tooltip/Tooltip';
import { IconPadlockLocked } from '@ui-lib';
import { motion } from 'motion/react';

import * as styles from './LockIndicator.css';

type LockIndicatorProps = {
  /** A message to show in a tooltip which shows when you hover the lock icon
   * If not provided the tooltip won't be rendered
   */
  tooltipMessage?: string;
};

export const LockIndicator = ({ tooltipMessage }: LockIndicatorProps): JSX.Element => {
  const lockIcon = (
    <motion.div
      className={styles.LockIndicator}
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          duration: 0.2,
          delay: 0.05,
        },
      }}
    >
      <IconPadlockLocked />
    </motion.div>
  );

  if (tooltipMessage) {
    return (
      <Tooltip
        showTriangle={true}
        type="dark-info"
        size="small"
        aria-label={tooltipMessage || 'Locked'}
        label={tooltipMessage || 'Locked'}
      >
        {lockIcon}
      </Tooltip>
    );
  }

  return lockIcon;
};
